import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import Pagination from "../Pagination/Pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Table from "../Table/Table";
import { SearchInput, SearchSubmitButton } from "../Form/Form";
import { capitalizeFirstLetter } from "../../util/fn";

const OBJ_TABLE = {
  user: "user",
  "User Email": "user",
  status: "status",
  "Failed Reason": "failedReason",
  "Created At": "createdAt",
};

const searchQueryHandler = (
  id,
  page,
  per_page,
  sortBy,
  order,
  dateFrom = "",
  dateTo = "",
  status = ""
) => {
  sortBy =
    sortBy.length > 0
      ? sortBy === "Created At"
        ? "createdAt"
        : sortBy
      : "createdAt";
  order = order.length > 0 ? order : "desc";

  return `custom-notification/get-log/${id}?page=${page}&per_page=${per_page}&sortBy=${sortBy}&order=${order}&dateFrom=${dateFrom}&dateTo=${dateTo}&status=${status}`;
};

const CustomNotificationListAll = (props) => {
  const { id } = props.match.params;

  const [emailTemplate, setEmailTemplate] = useState([]);
  const [page, setPage] = useState(1);
  const [totalDocuments, setTotalDocuments] = useState(1);
  const [perPage, setPerPage] = useState(0);
  const [currentSort, setCurrentSort] = useState({
    sortBy: "Created At",
    order: "desc",
  });

  const { records_per_page } = useSelector((state) => state.setting);

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    getValues,
    clearErrors,
  } = useForm();

  const { request, response } = useRequest();

  useEffect(() => {
    if (records_per_page) {
      setPerPage(records_per_page);
      request(
        "GET",
        searchQueryHandler(
          id,
          page,
          records_per_page,
          currentSort.sortBy,
          currentSort.order,
          "",
          "",
          ""
        )
      );
    }
    document.title = "Custom Notifications - Easyspare";
  }, [records_per_page]);

  useEffect(() => {
    if (response) {
      setEmailTemplate(response.data);
      setTotalDocuments((prev) => response?.pagination?.totalDocuments ?? prev);
    }
  }, [response]);

  const fetchMoreData = ({ selected }) => {
    setEmailTemplate([]);
    const { dateFrom, dateTo, status } = getValues();

    setPage(selected + 1);
    request(
      "GET",
      searchQueryHandler(
        id,
        selected + 1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        dateFrom,
        dateTo,
        status
      )
    );
  };

  const onSearchHandler = (data) => {
    const { dateFrom, dateTo, status } = data;
    request(
      "GET",
      searchQueryHandler(
        id,
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        dateFrom,
        dateTo,
        status
      )
    );
    setPage(1);
  };

  const onResetHandler = (e) => {
    e.preventDefault();
    resetField("dateFrom");
    resetField("dateTo");
    resetField("status");
    request(
      "GET",
      searchQueryHandler(
        id,
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        "",
        "",
        ""
      )
    );
    setPage(1);
  };

  const perPageChangeHandler = (event) => {
    const { dateFrom, dateTo, status } = getValues();
    request(
      "GET",
      searchQueryHandler(
        id,
        1,
        event.target.value,
        currentSort.sortBy,
        currentSort.order,
        dateFrom,
        dateTo,
        status
      )
    );
    setPage(1);

    setPerPage(event.target.value);
  };

  const sortingHandler = (sortBy) => {
    const { dateFrom, dateTo, status } = getValues();

    if (currentSort.sortBy == sortBy) {
      const newOrder = currentSort.order === "asc" ? "desc" : "asc";
      request(
        "GET",
        searchQueryHandler(
          id,
          page,
          perPage,
          sortBy,
          newOrder,
          dateFrom,
          dateTo,
          status
        )
      );
      setCurrentSort({ sortBy, order: newOrder });
    } else {
      request(
        "GET",
        searchQueryHandler(
          id,
          page,
          perPage,
          sortBy,
          "desc",
          dateFrom,
          dateTo,
          status
        )
      );
      setCurrentSort({ sortBy, order: "desc" });
    }
  };

  const InputFields = [
    {
      isSelectInput: true,
      label: "Status",
      name: "status",
      required: false,
      children: (
        <>
          <option value="">Select an option</option>
          <option value="pending">Pending</option>
          <option value="success">Success</option>
          <option value="failed">Failed</option>
        </>
      ),
    },
    {
      label: "Date From",
      name: "dateFrom",
      isDate: true,
      clearErrors,
    },
    {
      label: "Date To",
      name: "dateTo",
      isDate: true,
      clearErrors,
      otherRegisterFields: {
        manual: true,
        feedback: "'To Date' cannot be smaller than 'From Date'",
      },
    },
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Custom Notification Logs"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/custom-notification", name: "Back To Notification List" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="row">
            <div className="col-12">
              <div className="card card-custom card-stretch card-shadowless">
                <div className="card-header">
                  <div className="card-title"></div>
                  <div className="card-toolbar">
                    <a
                      /*href="#!"*/
                      className="btn btn-primary dropdown-toggle mr-2"
                      data-toggle="collapse"
                      data-target="#collapseOne6"
                    >
                      Search
                    </a>

                    {/* <Link
                      to="/custom-notification/send"
                      className="btn btn-primary"
                    >
                      Send Custom Notification
                    </Link> */}
                  </div>
                </div>
                <div className="card-body">
                  <div
                    className="accordion accordion-solid accordion-toggle-plus"
                    id="accordionExample6"
                  >
                    <div
                      id="collapseOne6"
                      className="collapse"
                      data-parent="#accordionExample6"
                    >
                      <div>
                        <form
                          onSubmit={handleSubmit(onSearchHandler)}
                          className="kt-form kt-form--fit mb-0"
                        >
                          <div className="row mb-6">
                            {InputFields.map((inputMain, index) => (
                              <SearchInput
                                key={index}
                                {...inputMain}
                                errors={errors}
                                register={register}
                              />
                            ))}
                          </div>

                          <SearchSubmitButton
                            handleSubmit={handleSubmit}
                            onSearchHandler={onSearchHandler}
                            onResetHandler={onResetHandler}
                          />
                        </form>
                        <hr />
                      </div>
                    </div>
                  </div>
                  <div className="dataTables_wrapper ">
                    <Table
                      currentSort={currentSort}
                      sortingHandler={sortingHandler}
                      mainData={emailTemplate}
                      tableHeading={Object.keys(OBJ_TABLE)}
                      tableData={Object.values(OBJ_TABLE)}
                      dontShowSort={["user", "User Email", "Failed Reason"]}
                      renderAs={{
                        user: (val) =>
                          val ? val.firstName + " " + val.lastName || "-" : "-",

                        "User Email": (val) => (val ? val.user.email : "-"),

                        // status: (val, id, data) =>
                        //   data
                        //     ? capitalizeFirstLetter(data?.status || "")
                        //     : "-",
                        status: (val) =>
                          val ? (
                            <span
                              style={{ height: "40px" }}
                              className={`label label-lg label-light-${
                                val === "success"
                                  ? "success"
                                  : val === "pending"
                                  ? "warning"
                                  : val === "failed"
                                  ? "danger"
                                  : ""
                              } label-inline`}
                            >
                              {capitalizeFirstLetter(val || "")}
                            </span>
                          ) : (
                            ""
                          ),
                      }}
                      onlyDate={{
                        createdAt: "dateTime",
                        startDate: "dateTime",
                        endDate: "dateTime",
                      }}
                    />

                    {perPage !== 0 && (
                      <Pagination
                        page={page}
                        totalDocuments={totalDocuments}
                        getNewData={fetchMoreData}
                        perPage={perPage}
                        defaultPerPage={records_per_page}
                        perPageChangeHandler={perPageChangeHandler}
                        currentDocLength={emailTemplate.length}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomNotificationListAll;
